import { Injectable } from "@angular/core";
import { ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config } from "../shared";
import { LoginSubjectLinksInstalledUsersDTOModel } from "../../data-transfer-objects/login-subject-links-installed-users-dto.model";
import { HttpClient, HttpParams } from "@angular/common/http";

@Injectable({ providedIn: 'root' })
export class LoginSubjectLinksInstalledUsersService extends BaseApiTemplateService<LoginSubjectLinksInstalledUsersDTOModel> {
  url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX
    + 'login-subject-links/installed-users/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.httpClient = http;
    this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX
      + 'login-subject-links/installed-users/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX
      + 'login-subject-links/installed-users/backoffice-ep';
  }

  getByAppletGuid(appletGuid: string, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '?';
    }
    const url = visa.api_domain_url + this.endpoint_path + '?';
    const headers = this.getHttpHeader(visa);
    const options = appletGuid
      ? {
        ...headers,
        params: new HttpParams().set('applet_hdr_guid', appletGuid)
      }
      : headers;
    return this.httpClient.get<ApiResponseModel<LoginSubjectLinksInstalledUsersDTOModel>>(url, options);
  }
}